import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwipeAnimationModule } from '@app/shared/ui/swipe-animation/swipe-animation.module';
import { TableListDesktopComponent } from './table-list-desktop/table-list-desktop.component';
import { TableListMobileComponent } from './table-list-mobile/table-list-mobile.component';

@NgModule({
  declarations: [ TableListDesktopComponent, TableListMobileComponent],
    imports: [
        CommonModule,
        SwipeAnimationModule
    ],
    exports: [TableListDesktopComponent, TableListMobileComponent]
})
export class TableListModule { }
